// extracted by mini-css-extract-plugin
export var container = "_5i-1";
export var cornerButtonContainer = "_5i-5";
export var disabled = "_5i-2";
export var fileContainer = "_5i-4";
export var hiddenInput = "_5i-3";
export var widthContainer = "_5i-0";